export const PROVIDER_PAGE_CONTENT_TYPE = 'pageContentType';
export const PROVIDER_PAGE_CONTENT_ID = 'pageContentId';
export const PROVIDER_PAGE_CONTENT = 'pageContent';
export const PROVIDER_PAGE_META_PROPERTIES = 'pageMetaProperties';
